<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称">
            <a-input :read-only="params.isShow" placeholder="请输入Banner名称" v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入Banner名称' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row class="form-row">

        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序索引">
            <a-input :read-only="params.isShow" type="number" placeholder="请输入排序索引" v-decorator="[
          'sortIndex',
          {initialValue:data.sortIndex,rules: [{ required: true, message: '请输入排序索引' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 有效期">
            <a-range-picker showTime :disabledDate="disabledDate" :disabled="this.params.isShow" v-decorator="[
          'rangeTime',
          {initialValue:data.rangeTime,rules: [{ required: true, message: '请选择有效期' }]}]" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="跳转类型">
            <a-select :disabled="this.params.isShow" placeholder="请选择字跳转类型" @change="typeChange" v-decorator="[
          'targetType',
          {initialValue:data.targetType,rules: [{ required: true, message: '请选择跳转类型' }]}]">
              <a-select-option value="0">无</a-select-option>
              <a-select-option value="1">产品</a-select-option>
              <a-select-option value="2">通知公告</a-select-option>
              <a-select-option value="3">促销活动</a-select-option>
              <a-select-option value="4">链接</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="data.targetType!=0 && data.targetType!=4">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="targetTypeLabel">
            <a-input-search :read-only="true" enterButton="选择" @search="onSearch" :placeholder="targetTypeMessage" v-decorator="[
          'targetName',
          {rules: [{ required: false, message: targetTypeMessage }],initialValue:data.targetName}]"></a-input-search>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row class="form-row" v-if="data.targetType==4">

        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="链接">
            <a-input :read-only="params.isShow" placeholder="请输入链接" v-decorator="[
          'targetUrl',
          {initialValue:data.targetUrl,rules: [{ required: false, message: '请输入链接' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传图片">
            <upload-image :showUploadList="{showPreviewIcon: true, showRemoveIcon: !this.params.isShow }" :imageInit="this.data.imageUrl" @uploadChange="uploadChange" :fileListInit="fileList" :imageCount="1" @cancelFile="cancelFile">
            </upload-image>
            <span style="color:red">建议上传图片尺寸为1200px*400px</span>
          </a-form-item>
        </a-col>
      </a-row>
      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
    <hp-manager-modal width="1200px" :title="'选择产品'" v-model="selectProductVisible">
      <hp-manager-page-product-select slot="slot" @getSelectedProduct="getSelectedProduct" @cancel="selectProductVisible = false"></hp-manager-page-product-select>
    </hp-manager-modal>
    <hp-manager-modal width="1200px" :title="'选择通知公告'" v-model="selectAnnouncementVisible">
      <hp-manager-page-announcement-select slot="slot" @getSelectedAnnouncement="getSelectedAnnouncement" @cancel="selectAnnouncementVisible = false"></hp-manager-page-announcement-select>
    </hp-manager-modal>
    <hp-manager-modal width="800px" :title="'选择活动'" v-model="selectActivityVisible">
      <hp-manager-page-activity-select slot="slot" @getSelectedActivity="getSelectedActivity" @cancel="selectActivityVisible = false"></hp-manager-page-activity-select>
    </hp-manager-modal>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import hpManagerPageProductSelect from "./../../Goods/Product/SelectProduct";
import hpManagerPageAnnouncementSelect from "./../../Information/Announcement/SelectList";
import hpManagerPageActivitySelect from "./../../Promotions/Activity/SelectList";
import { fail } from "assert";
const defaultData = {
  id: 0,
  name: "",
  sortIndex: "",
  isActive: "启用",
  startTime: null,
  rangeTime: null,
  endTime: null,
  targetType: "0",
  targetId: null,
  targetName: "",
  targetUrl: ""
};
export default {
  name: "hp-manager-page-banner-add",
  mixins: [account, dateFormat],
  components: {
    hpManagerPageProductSelect,
    hpManagerPageAnnouncementSelect,
    hpManagerPageActivitySelect
  },
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      defaultValue: [],
      targetTypeMessage: "",
      targetTypeLabel: "",
      listType: "text",
      selectProductVisible: false,
      selectAnnouncementVisible: false,
      selectActivityVisible: false,
      targetId: 0,
      fileList: []
    };
  },

  async mounted() {
    if (this.params.id) {
      this.getDetailBanner();
    } else {
      this.data = exzends(defaultData);
    }
  },

  methods: {
    typeChange(value) {
      if (value == 1) {
        this.targetTypeMessage = "请选择产品";
        this.targetTypeLabel = "产品";
      } else if (value == 2) {
        this.targetTypeMessage = "请选择通知公告";
        this.targetTypeLabel = "通知公告";
      } else if (value == 3) {
        this.targetTypeMessage = "请选择促销活动";
        this.targetTypeLabel = "促销活动";
      } else {
        this.targetTypeMessage = "";
        this.targetTypeLabel = "";
      }
      this.targetId = 0;
      this.form.setFields({
        targetName: { value: "", errors: null }
      });
      this.data.targetType = value;
    },
    onSearch(type) {
      if (this.data.targetType == 1) {
        this.selectProductVisible = true;
      } else if (this.data.targetType == 2) {
        this.selectAnnouncementVisible = true;
      } else if (this.data.targetType == 3) {
        this.selectActivityVisible = true;
      }
    },

    cancel() {
      this.$emit("cancel");
    },
    uploadChange(fileList) {
      this.fileList = fileList;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf("day");
    },
    cancelFile(fileList) {
      this.fileList = fileList;
    },
    getSelectedProduct(p) {
      this.selectProductVisible = false;
      this.form.setFields({
        targetName: { value: p.productName, errors: null }
      });
      this.targetId = p.id;
    },
    getSelectedAnnouncement(p) {
      this.selectAnnouncementVisible = false;
      this.form.setFields({
        targetName: { value: p.title, errors: null }
      });
      this.targetId = p.id;
    },
    getSelectedActivity(p) {
      this.selectActivityVisible = false;
      this.form.setFields({
        targetName: { value: p.title, errors: null }
      });
      this.targetId = p.id;
    },
    async getDetailBanner() {
      this.loading = true;
      let result = await api.GetBanner({ id: this.params.id });
      if (result) {
        this.data = result;
        this.data.rangeTime = [
          new moment(this.data.startTime),
          new moment(this.data.endTime)
        ];
        this.data.targetType = result.targetType + "";
        if (this.data.targetType == 1) {
          this.targetTypeMessage = "请选择产品";
          this.targetTypeLabel = "产品";
        } else if (this.data.targetType == 2) {
          this.targetTypeMessage = "请选择通知公告";
          this.targetTypeLabel = "通知公告";
        } else if (this.data.targetType == 3) {
          this.targetTypeMessage = "请选择促销活动";
          this.targetTypeLabel = "促销活动";
        }
        this.fileList.push({
          uid: Math.random().toString(),
          name: "1",
          status: "done",
          url: this.data.imageUrl
        });
      }
      this.loading = false;
    },

    async submitHandler() {
      await api.AddOrUpdateBanner(requestData);
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name,
        startTime: value.rangeTime[0].startOf("day").valueOf(),
        endTime: value.rangeTime[1].startOf("day").valueOf(),
        isActive: true,
        sortIndex: value.sortIndex,
        imageUrl: this.fileList.length > 0 ? this.fileList[0].url : "",
        targetType: value.targetType,
        targetId: this.targetId,
        targetName: value.targetName,
        targetUrl: value.targetUrl
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        if (requestData.imageUrl == "") {
          this.$message.warn("请上传Banner图片");
          this.loading = false;
          return;
        }
        if (this.params.id > 0) {
          data = await api.AddOrUpdateBanner(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.AddOrUpdateBanner(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Basic/Banner/Add.vue